module.exports = __webpack_public_path__ + "img/uid-popup.bae0ff75.png";